import React from 'react';
import { ATraiterView } from './components/ATraiterView';

export const ATraiterTab: React.FC = () => {
  return <ATraiterView />;
};